import {getArrayOfId} from "../../../utils";
import i18next from "../../../services/language/i18next";
import {ACTIONS, hasProjectPermission} from "../../../utils/user-access";

export function getTableColumnHeaders(projectRole) {
  const tableColumnHeaders = [
    {
      key: "status",
      label: i18next.t("table:header.state", "State"),
      _style: {width: "7%"},
      isShown: hasProjectPermission(ACTIONS.VIEW_PROJECT_CHECKS_LOG, projectRole)
    },
    {
      key: "created",
      label: i18next.t("table:header.when", "When"),
      isShown: hasProjectPermission(ACTIONS.VIEW_PROJECT_CHECKS_LOG, projectRole)
    }
  ];

  return tableColumnHeaders.filter(item => item.isShown);
}

export function getLastCheckStatus({is_up}) {
  return is_up ? "UP" : "DOWN";
}

/**
 * Converts rules with members_to_call and telegram_chats in the form of objects
 * into rules with members_to_call and telegram_chats in the form of array of id
 * @param {Array<Object>} rules - rules with members_to_call and telegram_chats in the form of objects
 * @returns {Array<Object>} - rules with members_to_call and telegram_chats in the form of array of id
 */
export function getRulesWithMembersAndChatsId(rules) {
  return rules.reduce((acc, rule) => {
    rule.members_to_call = getArrayOfId(rule.members_to_call);
    rule.telegram_chats = getArrayOfId(rule.telegram_chats);
    acc.push(rule);
    return acc;
  }, []);
}